export const ATTENDEE_FIELD_TYPES = ['text', 'number'] as const;

export type AttendeeFieldType = typeof ATTENDEE_FIELD_TYPES[number];

export const ATTENDEE_FIELD_TYPE_LABELS: Record<AttendeeFieldType, string> = {
  text: 'Texto',
  number: 'Número',
};

export interface AttendeeFieldDTO {
  id: string;
  event_id: string;
  label: string;
  /**
   * Fields created before the type picker existed come back without it: they
   * were all free text, so treat a missing value as `text`.
   */
  field_type?: AttendeeFieldType;
  mandatory: boolean;
  order: number;
  active: boolean;
}

export type CreateAttendeeFieldDTO = Omit<AttendeeFieldDTO, 'id' | 'event_id'>;

export type UpdateAttendeeFieldDTO = CreateAttendeeFieldDTO;

export const attendeeFieldType = (field: AttendeeFieldDTO): AttendeeFieldType => (
  field.field_type ?? 'text'
);
